import { BaseDto } from './base.dto';

export class RecipeWaytogoStepDto extends BaseDto {
  sequence: number;
  name?: string;
  description?: string;
  photoUrl?: string;
  recipeId?: number;
}
